import { createApp } from "vue"
import { IonicVue } from '@ionic/vue';

import App from './App.vue'
import store from "./store"
import router from "./router"
import "./assets/css/nucleo-icons.css"
import "./assets/css/nucleo-svg.css"

import ArgonDashboard from "./argon-dashboard"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import "./assets/css/easy.css"

const app = createApp(App)
.component("FontAwesomeIcon", FontAwesomeIcon)
.component("FontAwesomeIcon", faGoogle)
.use(store)
.use(IonicVue)
.use(router)
.use(Toast)
.use(ArgonDashboard);




app.config.globalProperties.$app_name = 'JS Logística';

router.isReady().then(() => {
  app.mount('#app');
});

